import { Component, OnInit, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {DataService} from '../../services/data.service';
import {ToastrService} from 'ngx-toastr';
import {ApiServices} from '../../services/api.service';
import {HelperService} from '../../services/helper.service';
import {Router} from '@angular/router';
import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialUser} from 'angularx-social-login';

@Component({
  selector: 'app-login-form',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginFormComponent implements OnInit {

  form: FormGroup;
  loginProcessing = false;
  loginSubscription: Subscription;
  user: SocialUser;
  loggedIn: boolean;
  @Output() showSignUp = new EventEmitter();

  isForgotPasswordForm = false;

  imageBasePath:string = "https://d2iosncs8hpu1u.cloudfront.net/";

  constructor(
    private dataService: DataService,
    private toastr: ToastrService,
    private apiService: ApiServices,
    private router: Router,
    private fb: FormBuilder,
    private authService: SocialAuthService,
    private helperService: HelperService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.authService.authState.subscribe((user) => {
      this.user = user;
      console.log(this.user);
      if (this.user) {
        this.socialLogin();
      }
      this.loggedIn = (user != null);
    });
  }


  socialLogin(): void {
    const formData = {
      first_name: this.user.firstName,
      last_name: this.user.lastName,
      email: this.user.email,
      provider: this.user.provider,
      avatar: this.user.photoUrl,
      social_auth: this.user.authToken,
      social_id: this.user.id
    };

    this.apiService.socialLogin(formData).subscribe(
      response => {
        if (response.status) {
          this.dataService.isLoggedIn.next(true);
          localStorage.setItem('ts_vendor_access_token', response.data.access_token);
          this.toastr.success(response.message);
          this.router.navigateByUrl('/profile-dashboard');
        }
      },
      err => {
        this.toastr.error(err.error.message);
      }
    );
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
  }


  onLogin(): void {
    if (this.form.valid) {
      this.loginProcessing = true;

      this.loginSubscription = this.apiService.login(this.form.value).subscribe(
        response => {
          this.loginProcessing = false;
          if (response.status) {
            //this.dataService.dealerlogo.next('https://d2iosncs8hpu1u.cloudfront.net/'+response.data.user_data.business_logo);
            // let dealerLogo = response.data.user_data;
            // this.dataService.dealerlogo.next('https://d2iosncs8hpu1u.cloudfront.net/'+response.data.user_data.business_logo);
            localStorage.setItem('ts_user_data', JSON.stringify(response.data));
            localStorage.setItem('ts_vendor_access_token', response.data.access_token);
            this.dataService.isLoggedIn.next(true);
            this.helperService.generateSessionId();
            this.setDealerLogo();
            this.toastr.success(response.message);
            this.getAddOnCategories();
            this.router.navigateByUrl('/profile-dashboard');
            localStorage.removeItem('override_cost_setting')

            this.getMyCart();
          } else {
            this.loginProcessing = false;
            this.toastr.error(response.message);
          }
        }, error => {
          this.loginProcessing = false;
          this.toastr.error(error.error.message);
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  getAddOnCategories(): void {
    this.apiService.getAddOnCategories().subscribe(response => {
      const data = response.data;
      this.dataService.setAddOnCategories(data);
    });
  }

  getMyCart(): void {
    const session_id = localStorage.getItem('session_id');
    if(!session_id){
      this.helperService.generateSessionId();
    }

    const access_token = localStorage.getItem('ts_vendor_access_token');
    if(access_token) {
      this.apiService.getCart().subscribe(response => {
        if (response.status) {
          this.dataService.setCartData(response);
        }
      });
    }
  }

  setDealerLogo(): void {
    const userData = JSON.parse(localStorage.getItem('ts_user_data'));
    if(this.helperService.isSubscribed(userData.user_data, 'plus-plan') || this.helperService.isSubscribed(userData.user_data, 'premium-plan')) {
        if(userData.user_data.business_logo != null){
          // this.dataService.dealerlogo.next(this.imageBasePath+userData.user_data.business_logo);
        }
    }
  }

  signUpForm(): void{
    this.showSignUp.emit();
  }

  forgotPasswordForm() {
    this.isForgotPasswordForm = true;
    this.form.controls.password.setValidators(null);
    this.form.controls.password.updateValueAndValidity();
  }

  loginForm() {
    this.isForgotPasswordForm = false;
    this.form.controls.password.setValidators([Validators.required]);
    this.form.controls.password.updateValueAndValidity();
  }

  ngOnDestroy() {
    if(this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  onForgot() {
    if (this.form.valid) {
      this.loginProcessing = true;

      this.loginSubscription = this.apiService.forgotPassword({email: this.form.value.email}).subscribe(
        response => {
          this.loginProcessing = false;
          if (response.status) {
            this.toastr.success(response.message);
            this.loginForm();
          } else {
            this.loginProcessing = false;
            this.toastr.error(response.message);
          }
        }, error => {
          this.loginProcessing = false;
          this.toastr.error(error.error.message);
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }
}
